import React, { useState } from "react";
import emailjs from "emailjs-com";
import "./Contact.css";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    message: "",
  });

  const [status, setStatus] = useState(""); // For success/error message

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .send(
        "service_br0quuz",      // 🔹 replace with EmailJS Service ID
        "template_36qluyr",     // 🔹 replace with Template ID
        {
  from_name: formData.name,
  phone: formData.phone,
  message: formData.message,
}
,
        "N99Ktk9dYZ3ZX43pN"       // 🔹 replace with your Public Key
      )
      .then(
        (response) => {
          console.log("SUCCESS!", response.status, response.text);
          setStatus("✅ Message sent successfully!");
          setFormData({ name: "", phone: "", message: "" });
        },
        (error) => {
          console.error("FAILED...", error);
          setStatus("❌ Failed to send message. Please try again.");
        }
      );
  };

  return (
    <section className="contact" id="contact">
      <div className="contact-container">
        <h2 className="section-title">Get in Touch</h2>
        <p className="section-subtitle">
          Have a project in mind? We’d love to hear from you.
        </p>

        <div className="contact-grid">
          {/* Left Side - Contact Info */}
          <div className="contact-info">
            <h3>Contact Information</h3>
            <p><i className="fas fa-map-marker-alt"></i> Sikar, Rajasthan</p>
            <p><i className="fas fa-envelope"></i> tej388286@gmail.com</p>
            <p><i className="fas fa-phone"></i> +91 8890914418</p>
          </div>

          {/* Right Side - Contact Form */}
          <form className="contact-form" onSubmit={handleSubmit}>
            <label htmlFor="name">Your Name</label>
            <input
              type="text"
              id="name"
              name="name"
              placeholder="John Doe"
              value={formData.name}
              onChange={handleChange}
              required
            />

            <label htmlFor="phone">Your Phone</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              placeholder="+91 1234567890"
              value={formData.phone}
              onChange={handleChange}
              required
            />

            <label htmlFor="message">Your Message</label>
            <textarea
              id="message"
              name="message"
              rows="5"
              placeholder="Write your message..."
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>

            <button type="submit" className="btn-submit">Send Message</button>
          </form>

          {/* Status message */}
          {status && <p className="status-message">{status}</p>}
        </div>
      </div>
    </section>
  );
};

export default Contact;
